import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class AIChatPanelService {
	private panels = signal<Record<string, boolean>>({})

	openPanels = this.panels.asReadonly()
	openPanels$ = toObservable(this.openPanels)

	toggleSideChat(open = undefined) {
		this.panels.set({
			...this.panels(),
			side: open ?? !this.panels().side
		})
	}
}
